import { WidgetForm } from '@/components/widget/WidgetForm';
import { useWidgetEmbed } from '@/hooks/use-widget-embed';

export default function EmbedWidget() {
  const embed = useWidgetEmbed();
  return <WidgetForm embed={embed} />;
}
